import React from "react";

const ContactUs = () => {
  return (
    <div className="contact-container">
      <div className="contact-bg">
        <div className="container content">
          <h1>Do You Want Custom Service? Contact Us Now</h1>
          <p>
            orem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua
          </p>
          <h4>
            <span>0123-456-789</span> for Immediate Tech Support
          </h4>
          <div className="button">
            <button>book services</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
